import React, { Component } from 'react';

import helpers from '../helpers/index';
import NavTop from '../components/nav-top';
import StaffTable from '../components/sub-accounts/staff-table';

class AdminStaffPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      staff: [],
      errorMessages: [],
      show_modal_error: false,
    };

    //TODO: check account type to make sure the user has proper permissions for this page
    // User must have:   admin === true && accountType === 'SUB-GROUP'
  }

  componentDidMount() {
    helpers.setSiteTitle('Admin Staff');
    // this.fetchData();
  }

  render() {
    return (
      <React.Fragment>

        <NavTop history={this.props.history} />

        <section className="wow fadeIn section animated" style={{visibility: 'visible', animationName: 'fadeIn'}}>
          <div className="container">
            <StaffTable isAdmin={true} showFooter={false} showFilter={true} headerBtnCssClass="btn btn-light btn-xs" />
          </div>
        </section>


      </React.Fragment>
    );
  }
}

export default AdminStaffPage;
